import { render, staticRenderFns } from "./ex-item.vue?vue&type=template&id=b503c17a&scoped=true&"
import script from "./ex-item.vue?vue&type=script&lang=js&"
export * from "./ex-item.vue?vue&type=script&lang=js&"
import style0 from "./ex-item.vue?vue&type=style&index=0&id=b503c17a&scoped=true&lang=scss&"
import style1 from "./ex-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b503c17a",
  null
  
)

export default component.exports